<template>
  <div>
    <base-header type="gradient-rmn" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <experiences-table></experiences-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExperiencesTable from "./Tables/ExperiencesTable";
export default {
  name: "experiences",
  components: {
    ExperiencesTable,
  },
};
</script>
<style></style>
